export const aboutWebsite = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://matthewbrimmer.com",
  name: "Matthew Brimmer | Software Engineer",
  author: {
    "@type": "Person",
    name: "Matthew Brimmer",
  },
};
export const siteMeta = {
  title: "Matthew Brimmer | Software Engineer",
  author: "Matthew Brimmer",
  description: "My personal website.",
  copyright: "Matthew Brimmer, Copyright (c) 2020",
  keywords: [
    "Matthew Brimmer",
    "fullstack engineer",
    "software engineer",
    "engineer",
  ],
};
